/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 12:12:46
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/CustomInformation/SimpleProductCustomInformationSection.tsx
 */
import React from 'react';
import CustomInformation from '../../Components/CustomInformation/CustomInformation';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCustomInfomationItems as setCustomInformationItems,
  setCustomInfomationItemsAddNew as setCustomInformationItemsAddNew,
} from '../Slice';
const SimpleProductCustomInfo = (props) => {
  const customsInformationItems = useSelector(
    (state: any) => state.simpleProduct.customsInformationItems,
  );
  const countries = useSelector((state: any) => state.simpleProduct.countries);
  const dispatch = useDispatch();
  const customInformationItemsOnChange = (isDelete, index, settings) => {
    dispatch(
      setCustomInformationItems({
        isDelete,
        index,
        settings,
      }),
    );
  };

  const customInformationItemsOnAdd = () => {
    dispatch(setCustomInformationItemsAddNew());
  };
  return (
    <CustomInformation
      disabled={props.disabled}
      items={customsInformationItems}
      countries={countries}
      customInformationItemsOnChange={customInformationItemsOnChange}
      customInformationItemsOnAdd={customInformationItemsOnAdd}
    />
  );
};
export default SimpleProductCustomInfo;
